
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ReportCard from '../follow/ReportCard.vue';
import AnalystReport from '../follow/AnalystReport.vue';
import CommonDropMenu from '@/components/common/CommonDropMenu.vue';
import { AVATAR_URL, MAGIC_THREE, THROTTLE_TIME, URLVER, STAT, MAGIC_FOUR } from '@/config/config';
import { getReadNum, getReport } from '@/apis/index';
import { throttle, getHangqing, getIsFollow, listSearch } from '@/utils/tools';
import CommonEmpty from '@/components/common/CommonEmpty.vue';
import CommonError from '@/components/common/CommonError.vue';
import CommonLoad from '@/components/common/CommonLoad.vue';

@Component({
  components: {
    ReportCard,
    AnalystReport,
    CommonDropMenu,
    CommonEmpty,
    CommonError,
    CommonLoad,
  },
})
export default class AllReport extends Vue {
  @Prop() private screenShow!: number;
  @Prop() private deep!: boolean;
  @Prop() private chart!: boolean;
  @Prop() private activeTabIndex!: number;
  @Prop() private slide!: number;
  followArr = [];
  //是否展示刷新页面
  showError = false;
  //是否展示加载中
  showLoad = false;
  //是否展示空状态
  showEmpty = false;
  //error样式
  errorStyle = {
    marginTop: '4rem',
  };
  //loading样式
  loadStyle = {
    marginTop: '6rem',
  };
  //空状态样式
  emptyStyle = {
    fontFamily: 'PingFangSC-Regular',
    fontSize: '0.32rem',
    color: 'rgba(0, 0, 0, 0.84)',
    textAlign: 'center',
    lineHeight: '0.4rem',
  };
  //下拉框默认选项
  defaultValue = '最新';
  //阅读量对象
  newObj = {};
  //头像地址
  AVATAR_URL = AVATAR_URL;
  //魔法值3
  MAGIC_THREE = MAGIC_THREE;
  //节流时间
  THROTTLE_TIME = THROTTLE_TIME;
  //下拉选项
  options = [
    { label: '最新', value: 0 },
    { label: '近24h最热', value: 1 },
    { label: '近1周最热', value: 2 },
    { label: '近1⽉最热', value: 3 },
    { label: '近3⽉最热', value: 4 },
  ];
  //.screen 页面上滑时的间距
  marginStyle = {
    marginTop: '0.88rem',
  };
  //查询阅读量的参数拼接
  str = '';
  //查询是否关注的参数拼接
  follorStr: any[] = [];
  //下拉框周期选择
  period = '';
  //研报列表
  reportList = [] as any[];
  //存放scrollTop
  scrollTop = 0;
  //存放clientHeight
  clientHeight = 0;
  //是否展示加载中
  showLoading = false;
  //是否展示没有更多
  showNoMore = false;
  //研报分页请求传递的当页最后一个研报编号
  lastSeq = 0;
  //如果传回的分页数据为空则不再请求分页的参数
  stopReq = false;
  // 是否被激活
  isActived = false;
  //分页底部是否展示
  showItems = false;
  //分页页数
  pages = 0;
  //监听是否是深度研报的参数，如果改变则请求相应数据
  @Watch('deep')
  onDeepChange() {
    this.pages = 0;
    if (this.deep) {
      getReport(
        this.period === ''
          ? {
              report_type: 'self_stock',
              is_deep: 1,
            }
          : {
              report_type: 'self_stock',
              period: this.period,
              is_deep: 1,
            }
      ).then(res => {
        this.dealRes(res);
      });
    } else {
      getReport(
        this.period === ''
          ? {
              report_type: 'self_stock',
            }
          : {
              report_type: 'self_stock',
              period: this.period,
            }
      ).then(res => {
        this.dealRes(res);
      });
    }
  }
  dealRes(res: any) {
    const LIST = res.data?.list;
    listSearch(this, LIST);
    this.reportList = LIST;
    this.lastSeq = LIST[LIST.length - 1]?.seq;
    this.getReadFollowHQ(LIST, res);
  }
  @Watch('activeTabIndex')
  onActiveTabIndexChanged(newValue: number) {
    if (newValue === 2 + this.slide) {
      if (!this.isActived) {
        this.activeComp();
      }
      this.isActived = true;
    }
  }
  //如果数据列表为空则展示空状态
  @Watch('reportList')
  onReportListChange() {
    if (this.reportList.length === 0) {
      this.showEmpty = true;
      this.showItems = false;
    } else {
      this.showItems = true;
      this.showEmpty = false;
    }
  }
  //接口异常时刷新
  refresh() {
    this.showError = false;
    this.activeComp();
  }
  getScrollHeight() {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
  }
  //滚动加载
  scrollLoading() {
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    this.clientHeight = document.body.clientHeight || document.documentElement.clientHeight;
    const SCROLL_BIAS = 10;
    if (this.scrollTop + this.clientHeight + SCROLL_BIAS >= this.getScrollHeight()) {
      this.showLoading = true;
      if (!this.stopReq && this.activeTabIndex === 2 + this.slide) {
        this.pages = this.pages + 1;
        this.mergeList();
      } else {
        this.showNoMore = true;
        this.showLoading = false;
      }
    } else {
      this.showNoMore = false;
      this.showLoading = false;
    }
    // const chart = document.getElementsByClassName('card')[0] as HTMLElement;
    // console.log(chart.offsetWidth, this.scrollTop);
  }
  //滚动加载合并数据
  mergeList() {
    if (this.deep) {
      getReport(
        this.period === ''
          ? {
              page: this.pages,
              report_type: 'self_stock',
              seq: this.lastSeq,
              is_deep: 1,
            }
          : {
              page: this.pages,
              report_type: 'self_stock',
              seq: this.lastSeq,
              period: this.period,
              is_deep: 1,
            }
      ).then(res => {
        this.dealScrollResponse(res);
      });
    } else {
      getReport(
        this.period === ''
          ? {
              page: this.pages,
              report_type: 'self_stock',
              seq: this.lastSeq,
            }
          : {
              page: this.pages,
              report_type: 'self_stock',
              seq: this.lastSeq,
              period: this.period,
            }
      ).then(res => {
        this.dealScrollResponse(res);
      });
    }
  }
  radioChartChange(val: any) {
    if (val) {
      window.hxmPageStat(`${STAT.zxg}.ontb`, URLVER);
    } else {
      window.hxmPageStat(`${STAT.zxg}.offtb`, URLVER);
    }
    this.$emit('radioChartChange');
  }
  radioDeepChange(val: any) {
    if (val) {
      window.hxmPageStat(`${STAT.zxg}.onsd`, URLVER);
    } else {
      window.hxmPageStat(`${STAT.zxg}.offsd`, URLVER);
    }
    this.$emit('radioDeepChange');
  }
  getReadFollowHQ(LIST: any, res: any) {
    this.getReadCount(LIST);
    getIsFollow(this, LIST, null);
    this.getHangqing(res);
  }
  //处理滚动加载数据
  dealScrollResponse(res: any) {
    this.showLoading = false;
    const LIST = res.data?.list;
    listSearch(this, LIST);
    if (LIST?.length > 0) {
      this.reportList = [...this.reportList, ...LIST];
      this.lastSeq = LIST[LIST.length - 1].seq;
      this.getReadFollowHQ(LIST, res);
    } else {
      this.showNoMore = true;
      this.stopReq = true;
    }
  }
  //下拉选项改变时处理数据
  dealResponse(res: any) {
    const LIST = res.data?.list;
    this.reportList = LIST;
    if (LIST.length > 0) {
      this.lastSeq = LIST[LIST.length - 1]?.seq;
      this.getReadFollowHQ(LIST, res);
    }
  }
  //下拉选项发生改变
  selected(item: any) {
    this.showNoMore = false;
    this.stopReq = false;
    this.$emit('changeSelect', item.label);
    this.defaultValue = item.label;
    this.pages = 0;
    switch (item.value) {
      case 0:
        this.period = '';
        break;
      case 1:
        this.period = '1d';
        break;
      case 2:
        this.period = '1w';
        break;
      case 3:
        this.period = '1m';
        break;
      case 4:
        this.period = '3m';
        break;
      default:
        return;
    }
    //看是深度还是普通研报，请求相应数据
    if (this.deep) {
      getReport(
        item.value === 0
          ? {
              is_deep: 1,
              report_type: 'self_stock',
            }
          : {
              is_deep: 1,
              period: this.period,
              report_type: 'self_stock',
            }
      ).then(res => {
        this.dealResponse(res);
      });
    } else {
      getReport(
        item.value === 0
          ? {
              report_type: 'self_stock',
            }
          : {
              report_type: 'self_stock',
              period: this.period,
            }
      ).then(res => {
        this.dealResponse(res);
      });
    }
  }
  //拼接获取阅读量的参数
  getReadCount(LIST: Array<object>) {
    this.str = '';
    for (let i: number = 0; i < LIST.length; i++) {
      const k = LIST[i] as any;
      if (i !== LIST.length - 1) {
        this.str = `${this.str}seq_${k.pid},`;
      } else {
        this.str = `${this.str}seq_${k?.pid}`;
      }
    }
    //获取阅读量
    getReadNum({
      field: 'clicks',
      key: this.str,
    }).then(res1 => {
      const that = this;
      const response = res1 as any;
      const obj = response.result;
      if (obj) {
        Object.getOwnPropertyNames(obj).forEach(function (key) {
          that.$set(that.newObj, key.substr(MAGIC_THREE), obj[key]);
          for (let k: number = 0; k < that.reportList.length; k++) {
            if (key.substr(MAGIC_FOUR) == that.reportList[k].pid) {
              that.$set(that.reportList[k], 'readNum', obj[key]);
            }
          }
        });
      }
    });
  }
  getIsFollow(LIST: Array<object>, id: any) {
    getIsFollow(this, LIST, id);
  }
  //获取行情
  getHangqing(res: any) {
    getHangqing(res);
  }

  activeComp() {
    window.hxmPageStat(`${STAT.zxg}`, URLVER);
    this.showLoad = true;
    window.addEventListener(
      'scroll',
      throttle(() => this.scrollLoading(), THROTTLE_TIME),
      true
    );
    //获取自选股
    getReport({
      report_type: 'self_stock',
    })
      .then(res => {
        const LIST = res.data?.list;
        listSearch(this, LIST);
        this.showLoad = false;
        this.showError = false;
        if (LIST.length === 0) {
          this.showEmpty = true;
        } else {
          this.showEmpty = false;
        }
        this.reportList = LIST;
        this.lastSeq = LIST[LIST.length - 1]?.seq;
        this.getReadFollowHQ(LIST, res);
        //在接口里将非active的slide高度置为0
        // const swiper = document.getElementsByClassName('swiper-wrapper')[0].children;
        // const slide = swiper[MAGIC_TWO] as HTMLElement;
        // const slide2 = swiper[1] as HTMLElement;
        // slide.style.height = '0';
        // slide2.style.height = '0';
      })
      .catch(() => {
        this.showLoad = false;
        this.showEmpty = false;
        this.showError = true;
        this.isActived = false;
      });
  }
}
